<div class="card">
    <!-- Card body -->
    <div class="card-body">    
        <div class="row align-items-center">
            <div class="col-auto mb-2">
                        <!-- Avatar -->        
                <a href="#" class="avatar avatar-xl rounded-circle">
                    <img alt="Image placeholder" src="../../assets/img/theme/team-2.jpg">
                </a>
            </div>
            <div class="col ml--2">
                <h4 class="mb-0">
                    <a href="#!"> Current Account : {{accountInformation.school.name}}</a>
                </h4>        
                <p class="text-sm  mb-0"> You are currently using a <strong> {{Tiername}} </strong>  Account </p>       
                
                <p class="text-sm  mb-0" *ngIf="accountInformation.schoolConfig.tier != 1"> Your current subscription expires <strong> {{accountInformation.schoolConfig.enddate_string}} </strong>  </p>       
            </div>
            <div class="col-auto">        
                <button type="button" class="btn btn-sm btn-primary">RENEW</button>
                <button type="button" class="btn btn-sm btn-primary">CHANGE PLAN</button>
            </div>
        </div>
    </div>
</div>

<div class="row mb-4">

    <div class="col-lg-8 row">
        
        <div class="col-lg-6">
            <div class="card card-stats">
                <!-- Card body -->
                <div class="card-body">                
                    <div class="row">
                        <div class="col">
                            <h5 class="card-title text-uppercase text-muted mb-0">Total Students / Plan Limit</h5>
                            <span class="h2 font-weight-bold mb-0">{{accountInformation.studentCount}} / {{accountInformation.schoolConfig.studentCountMax}} </span>
                        </div>
                        <div class="col-auto">
                        <div class="icon icon-shape bg-red text-white rounded-circle shadow">
                            <i class="ni ni-active-40"></i>
                        </div>
                        </div>
                    </div>           
                </div>
            </div>
        </div>
      
        <div class="col-lg-6">
            <div class="card card-stats">
                <!-- Card body -->
                <div class="card-body">
                    
                <div class="row">
                    <div class="col">
                        <h5 class="card-title text-uppercase text-muted mb-0">Total Storage / Plan Limit</h5>
                        <span class="h2 font-weight-bold mb-0"> {{usedSpaceGB}} GB / {{tierSpaceGB}} GB</span>
                    </div>
                    <div class="col-auto">
                    <div class="icon icon-shape bg-red text-white rounded-circle shadow">
                        <i class="ni ni-active-40"></i>
                    </div>
                    </div>
                </div>
                <!-- <p class="mt-3 mb-0 text-sm">
                    <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                    <span class="text-nowrap">Balance</span>
                </p> -->
                </div>
            </div>
        </div>   
           
    </div>

    <div class="col-lg-4">
        <div class="col-lg-12">
            <div class="card">
                <!-- Card header -->
                <div class="card-header border-0">
                  <div class="row">
                    <h3 class="mb-0">Account Tier details</h3>                   
                  </div>
                </div>
                <!-- Light table -->
                <div class="table-responsive">
                  <table class="table align-items-center table-flush table-hover">
                    <thead class="thead-light">
                      <tr>                       
                        <th></th>
                        <th>Enabled</th>                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of TierFuncs">                   
                        <td class="table-user">
                          <div style="
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    background: transparent;
    z-index: 1;
"> </div>
                          <b>{{item.title}}</b>
                        </td>                       
                        <td>
                          <label class="custom-toggle">
                            <input type="checkbox" *ngIf="item.active" checked>
                            <input type="checkbox"  *ngIf="!item.active" >                            
                            <span class="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>
                          </label>
                        </td>
                      </tr>                 
                    </tbody>
                  </table>
                </div>
              </div>
        </div>
    </div>
   
   
</div>